import system from './system'
import table from './table'
import value from './value'
import mask from './mask'

export default {
  system,
  table,
  value,
  mask
}



// WEBPACK FOOTER //
// ./src/translate/pt_br/pt-br.js